import * as React from 'react';
import * as Redux from 'react-redux';
import dayjs from 'dayjs';
import { Calendar, Views, dayjsLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { useNotification } from '../../../helpers/Notification';
import { PARAMS_EVENTOS, SLOTINFO_EVENTOS } from '../ReportesReducer';
import { allReportesAction, setActivoReportesAction } from '../ReportesAction';
import { messagesCalendar } from '../../control_estudios/horarios/components/VistaHorarios';
import PersonIcon from '@mui/icons-material/Person';
import PeopleIcon from '@mui/icons-material/People';

const localizer = dayjsLocalizer(dayjs);

const CalendarioReportesComponent = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const reportesStore = Redux.useSelector((state) => state.reportes);

  const [reportes, setReportes] = React.useState([]);
  const [view, setView] = React.useState(Views.MONTH);

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {
        ...reportesStore.params,
        usuario: loginStore.user.id,
      };
      dispatch({
        type: PARAMS_EVENTOS,
        payload,
      });
      if (reportesStore.all && reportesStore.all.length === 0) {
        await allReportesAction(dispatch, payload);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    let events = [];
    reportesStore.all.forEach((el) => {
      events.push({
        id: el.id,
        evento: el,
        color: el.color,
        start: dayjs(el.inicio).toDate(),
        end: dayjs(el.fin).toDate(),
        title: el.nombre,
      });
    });
    setReportes(events);
  }, [reportesStore.all]);

  const event = (eventProps) => {
    const { event } = eventProps;
    const isMonth = view === Views.MONTH;
    // Personaliza el estilo de cada evento
    const eventStyle = {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    };

    const styleTextCalendar = {
      fontSize: isMonth ? '10pt' : '12pt',
      fontWeight: 'bold',
    };

    return (
      <Box sx={eventStyle}>
        {event.evento ? (
          <>
            <Stack direction="row" spacing={1} alignItems="center">
              {isMonth &&
                (event.evento.public ? (
                  <PeopleIcon fontSize="inherit" sx={{ color: 'white' }} />
                ) : (
                  <PersonIcon fontSize="inherit" sx={{ color: 'white' }} />
                ))}
              <Typography sx={styleTextCalendar}>{event.title}</Typography>
            </Stack>
            {!isMonth && (
              <Typography
                sx={{
                  ...styleTextCalendar,
                  fontSize: '7pt',
                }}
              >
                {event.evento.desc}
              </Typography>
            )}
            {/* <Typography sx={{ fontSize: '9pt' }}>
              {event.evento.seccion.nivelAcademico.nivelAcademico.abrev}
              {' - '}
              {event.evento.seccion.nombre}
            </Typography>
            <Typography sx={{ ...styleTextCalendar, fontSize: '8pt' }}>
              {event.evento.docente.usuario.perfil.pnombre}{' '}
              {event.evento.docente.usuario.perfil.papellido}
            </Typography>

            {!reportesStore.settings.isEstatus && event.evento.aula ? (
              <Typography
                sx={{
                  ...styleTextCalendar,
                  fontSize: '8pt',
                }}
              >
                Aula: {event.evento.aula?.nombre}
              </Typography>
            ) : null}
            {!reportesStore.settings.isEstatus ? null : (
              <Chip
                label={event.evento.estatus.nombre}
                size="small"
                sx={{
                  fontSize: '7pt',
                }}
                color={event.evento.estatus.id === 1 ? 'success' : 'error'}
              />
            )} */}

            {!isMonth &&
              (event.evento.public ? (
                <Stack direction="row" spacing={1} alignItems="center">
                  <PeopleIcon fontSize="inherit" sx={{ color: 'white' }} />
                  <Typography
                    variant="caption"
                    color="white"
                    sx={{ fontWeight: 'bold' }}
                  >
                    Público
                  </Typography>
                </Stack>
              ) : (
                <Stack direction="row" spacing={1} alignItems="center">
                  <PersonIcon fontSize="inherit" sx={{ color: 'white' }} />
                  <Typography
                    variant="caption"
                    color="white"
                    sx={{ fontWeight: 'bold' }}
                  >
                    Personal
                  </Typography>
                </Stack>
              ))}
          </>
        ) : (
          <>
            <Typography
              sx={{ textAlign: 'start', fontSize: '9pt', width: '100%' }}
            >
              {event.title}
            </Typography>
          </>
        )}
      </Box>
    );
  };

  function handleMonthChange(date) {
    console.log('El mes fue cambiado a: ', date);
  }

  return (
    <Paper elevation={4} sx={{ p: 2 }}>
      <Calendar
        messages={messagesCalendar}
        localizer={localizer}
        defaultDate={dayjs()}
        style={{ height: '100vh' }}
        events={reportes}
        views={['month', 'week']}
        view={view}
        onView={(newView) => setView(newView)}
        selectable
        popup
        onSelectSlot={(slotInfo) => {
          setActivoReportesAction(dispatch, null);
          dispatch({
            type: SLOTINFO_EVENTOS,
            payload: slotInfo,
          });
          setOpenModalForm(true);
        }}
        components={{
          event,
        }}
        onRangeChange={handleMonthChange}
        eventPropGetter={(event) => {
          let style = {
            backgroundColor: event.color ?? '#2b2b2b',
            color: 'white',
            borderRadius: '7px',
            border:
              event.id === reportesStore.activo?.id
                ? 'solid 3px blue'
                : event.horario?.estatus.id === 2
                ? 'solid 1px red'
                : 'solid 1px white',
            fontSize: '10pt',
          };

          if (event.isMine) {
            style.backgroundColor = 'lightgreen';
          }

          return {
            className: '',
            style,
          };
        }}
        onSelectEvent={(event, e) => {
          setActivoReportesAction(dispatch, event.evento);
          setOpenModalForm(true);
        }}
      />
    </Paper>
  );
};

export default CalendarioReportesComponent;
